import { NewEnumTranslator as EnumTranslator } from '@skylab-shared/dataModel';

export const ArrearKind = {
	All: 1,
	OnTime: 2,
	Overdue: 3
} as const;

export type ArrearKind = typeof ArrearKind[keyof typeof ArrearKind];

EnumTranslator.registerEnum(ArrearKind, 'ArrearKind');
